import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translations
import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import it from './locales/it.json';

// Detect language from browser
const getDefaultLanguage = () => {
  const savedLanguage = localStorage.getItem('language');
  if (savedLanguage) return savedLanguage;

  const browserLanguage = navigator.language.split('-')[0];
  const supportedLanguages = ['de', 'en', 'fr', 'es', 'it'];
  
  return supportedLanguages.includes(browserLanguage) ? browserLanguage : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
    },
    lng: getDefaultLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
